import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "product-confirm-solicitation-dialog",
  templateUrl: "./product-confirm-solicitation-dialog.component.html",
  styleUrls: ["./product-confirm-solicitation-dialog.component.scss"]
})
export class ProductConfirmSolicitationDialog {
  constructor(public matDialogRef: MatDialogRef<ProductConfirmSolicitationDialog>) {}

  closeDialog(close: boolean) {
    this.matDialogRef.close({ close: close });
  }
}
